import React from "react";
import "./contact-office.css";

import headOfficeImg from "../../images/webtechhome/trifecta-adatto.jpg";
import branchOfficeImg from "../../images/webtechhome/branchoffice.png";
import arrowWhite from "../../images/icon/rotate-arrow-white02.svg";
import arrowBlack from "../../images/icon/rotate-arrow-black03.svg";
import callIcon from "../../images/icon/call-icon.svg";
import emailIcon from "../../images/icon/email-icon.svg";
import {
  CONTACT_ADDRESS,
  CONTACT_BRANCH_ADDRESS,
  CONTACT_BRANCH_MAP_URL,
  CONTACT_EMAIL,
  CONTACT_MAP_URL,
  CONTACT_PHONE,
  CONTACT_PHONE_TEL,
} from "../../config/contact";

const contactData = [
  {
    location: "Head Office",
    address: CONTACT_ADDRESS,
    phone: CONTACT_PHONE,
    email: CONTACT_EMAIL,
    img: headOfficeImg,
    imgAlt: "WebTech head office at Trifecta Adatto, Mahadevpura",
    mapUrl: CONTACT_MAP_URL,
  },
  {
    location: "Branch Office",
    address: CONTACT_BRANCH_ADDRESS,
    phone: CONTACT_PHONE,
    email: CONTACT_EMAIL,
    img: branchOfficeImg,
    imgAlt: "WebTech branch office at 122 Optima, Whitefield",
    mapUrl: CONTACT_BRANCH_MAP_URL,
  },
];

const ContactInfoSection: React.FC = () => {
  return (
    <section className="contact pb-150">
      <div className="container">
        <div className="row mt-none-30 justify-content-center">
          {contactData.map((item) => (
            <div className="col-lg-6 col-md-8 mt-30" key={item.location}>
              <div className="xb-contact-items contact-office-card xb-border">
                <div className="xb-item--inner">
                  <div className="contact-office-card__img">
                    <a href={item.mapUrl} target="_blank" rel="noopener noreferrer">
                      <img src={item.img} alt={item.imgAlt} />
                    </a>
                  </div>

                  <div className="xb-item--holder">
                    <p className="xb-item--location">{item.location}</p>
                    <p className="xb-item--contact_info">{item.address}</p>

                    <div className="contact-office-card__info-row">
                      <img src={callIcon} alt="" aria-hidden="true" />
                      <a href={`tel:${CONTACT_PHONE_TEL}`}>{item.phone}</a>
                    </div>

                    <div className="contact-office-card__info-row">
                      <img src={emailIcon} alt="" aria-hidden="true" />
                      <a href={`mailto:${item.email}`}>{item.email}</a>
                    </div>

                    <a
                      href={item.mapUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="thm-btn form-btn mt-45"
                    >
                      VIEW LOCATION
                      <span className="xb-icon">
                        <img src={arrowWhite} alt="" aria-hidden="true" />
                        <img src={arrowBlack} alt="" aria-hidden="true" />
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ContactInfoSection;
